import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import { useNavigate, useParams } from "react-router-dom";
import { SITE_URL } from "../../services/Const";
import NoDataHandler from "../../components/common/NoDataHandler";
import LoadingComponent from "../../components/common/LoadingComponent";
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveCurrencies } from "../../redux/ecommerce/currency/actions";

const OrderDetails = () => {
    const { orderId } = useParams()
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const { currencies } = useSelector(state => state.Currency);
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(fetchActiveCurrencies()); // must be called
    }, [dispatch]);

    useEffect(() => {
        getData();

    }, []);

    const getData = () => {
        setLoading(true);
        setData([]); // Reset data before fetching new data

        axiosConfig.get(`get-order-details/${orderId}`, setHeader())
            .then((res) => {
                setData(res.data.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setLoading(false); // ✅ This will run after the promise resolves/rejects
            });
    };

    // Helper function to get order status text
    const getOrderStatusText = (status) => {
        const statusMap = {
            0: 'Pending',
            1: 'Accepted',
            2: 'Dispatch',
            3: 'Shipped',
            4: 'Delivered',
            5: 'Rejected',
            6: 'Return',
            7: 'User Canceled'
        };
        return statusMap[status] || 'Unknown';
    };

    // Show loading state first
    if (loading) {
        return (
            <LoadingComponent breadCrubTitle='Order Details' breadCrubParent='Sales Report' />
        );
    }

    // Show no data only after loading is complete and data is empty
    if (!loading && data.length === 0) {
        return (
            <Fragment>
                <Breadcrumb title="Order Details" parent="Sales Report" />
                <NoDataHandler title='Order Details Not Found' />
            </Fragment>
        );
    }
    return (
        <Fragment>
            <Breadcrumb title="Order Details" parent="Sales Report" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">Product Name</th>
                                        <th scope="col">Order ID</th>
                                        <th scope="col">Order Date</th>
                                        <th scope="col">Invoice No.</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col">Quantity</th>
                                        <th scope="col">Payment Mode</th>
                                        <th scope="col">Order Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td>
                                                    <img
                                                        width="100"
                                                        height="50"
                                                        src={`${SITE_URL}/images/product/${JSON.parse(item.images || "[]")[0]}`} alt="" />
                                                </td>
                                                <td>{item.productName}</td>
                                                <td>{item.order_id}</td>
                                                <td>
                                                    {(() => {
                                                        const orderDate = new Date(item.order_date);
                                                        const year = orderDate.getFullYear();
                                                        const month = orderDate.toLocaleString('default', { month: 'long' }); // "June"
                                                        const day = orderDate.getDate(); // 26
                                                        return `${year} ${month} ${day}`;
                                                    })()}
                                                </td>
                                                <td>{item.invoice_no}</td>
                                                <td>{currencies?.symbol} {item.amount}</td>
                                                <td>{item.qty}</td>
                                                <td>{item.payment_mode === 'COD' ? 'COD' : 'Prepaid'}</td>
                                                <td>{getOrderStatusText(item.order_status)}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <button className="btn btn-primary" style={{ marginTop: '1rem' }} onClick={() => navigate(-1)}>Back</button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default OrderDetails;
